import { TagApiModel } from './tag.api.model';

export class TagGroupApiModel {
  symbol: string;

  description: string;

  tags: TagApiModel[];
}
